export const syncCalendar = {
  title: "زامن تقويماتك",
  description:
    "هل مكان إقامتك معروض على عدة مواقع؟ ستساعدك مزامنة تقويماتك على رؤية حجوزاتك وتوافرك عبر جميع القنوات في آنٍ واحد. يمكنك استيراد التقويمات وتصديرها بصيغة iCal والحفاظ على قائمة تسجيلات الوصول المجدولة محدّثة.",
  accommodation: "مكان الإقامة",
  sync: "مزامنة",
  addCalendar: "إضافة تقويم جديد",
  confirmSync: {
    message: "هل تريد تحديث التقويمات؟",
  },
  syncSuccess: {
    message: "تمت مزامنة التقويمات بنجاح",
    title: "نجحت المزامنة",
  },
  calendarName: "اسم التقويم",
  modal: {
    header: "إضافة تقويم",
    nameLabel: "أدخل اسم التقويم",
    linkLabel: "انسخ رابط تقويمك والصقه هنا",
    linkPlaceholder: "رابط iCal",
    cancel: "إلغاء",
    save: "حفظ ومزامنة",
  },
  saveSuccess: {
    message: "نجاح",
    title: "تم حفظ التقويم بنجاح",
  },
  errors: {
    validationTitle: "فشل التحقق",
    saveErrorTitle: "خطأ في حفظ التقويم",
    unexpected: "حدث خطأ غير متوقع.",
  },
  list: {
    updated: "آخر تحديث",
    status: "الحالة",
    synced: "متزامن",
    delete: "حذف",
    empty: "لا توجد تقويمات متزامنة",
  },
  deleteConfirm: {
    title: "هل تريد حذف التقويم؟",
    content:
      'عند حذف التقويم، ستُحذف أيضًا الحجوزات المتزامنة في قائمة "تسجيلات الوصول المجدولة (الحجوزات)"',
  },
  deleteSuccess: {
    message: "تم حذف التقويم بنجاح",
    title: "تم الحذف",
  },
  deleteError: {
    message: "خطأ في حذف التقويم",
    title: "خطأ",
  },
};
